import { Link } from 'react-router-dom'
import type { AlertRow } from './types'

const LEVEL_STYLES: Record<AlertRow['level'], { bg: string; title: string; desc: string }> = {
  critical: { bg: 'bg-red-50 border-red-200', title: 'text-red-900', desc: 'text-red-700' },
  warning: { bg: 'bg-amber-50 border-amber-200', title: 'text-amber-900', desc: 'text-amber-700' },
  info: { bg: 'bg-blue-50 border-blue-200', title: 'text-blue-900', desc: 'text-blue-700' },
}

export function AlertsPanel({ alerts }: { alerts: AlertRow[] }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm text-gray-500">Узкие места</div>
        {alerts.length > 0 && (
          <span className="text-xs px-1.5 py-0.5 rounded bg-red-100 text-red-700">
            {alerts.length} алёрт{alerts.length > 1 ? 'а' : ''}
          </span>
        )}
      </div>

      {alerts.length === 0 ? (
        <p className="text-sm text-gray-400 py-2">Всё в порядке</p>
      ) : (
        <div className="space-y-2 max-h-[440px] overflow-y-auto pr-1">
          {alerts.map((a) => {
            const styles = LEVEL_STYLES[a.level]
            const body = (
              <div className={`rounded-lg border p-3 ${styles.bg}`}>
                <div className={`text-sm font-medium ${styles.title}`}>{a.message}</div>
                {a.description && (
                  <div className={`text-xs mt-0.5 ${styles.desc}`}>{a.description}</div>
                )}
              </div>
            )
            return a.actionUrl ? (
              <Link key={a.id} to={a.actionUrl} className="block hover:opacity-95">
                {body}
              </Link>
            ) : (
              <div key={a.id}>{body}</div>
            )
          })}
        </div>
      )}
    </div>
  )
}
